import React from 'react';

interface CloseActiveProps {
  size?: number;
  color?: string;
}

const CloseActiveIcon: React.FC<CloseActiveProps> = function (props: CloseActiveProps) {
  const {
    size = 40,
    color = '#F97171',
  } = props;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width={size - 1} height={size - 1} rx={size / 10} fill={color} stroke={color} />
      <path d={`M${size * 0.65} ${size * 0.35}L${size * 0.35} ${size * 0.65}`} stroke="white" strokeLinecap="square" strokeLinejoin="round" />
      <path d={`M${size * 0.35} ${size * 0.35}L${size * 0.65} ${size * 0.65}`} stroke="white" strokeLinecap="square" strokeLinejoin="round" />
    </svg>
  );
};

CloseActiveIcon.defaultProps = {
  size: 40,
  color: '#F97171',
};

export default CloseActiveIcon;
